import { z } from 'zod';

export const addressRestrictions = [
  'Gated community',
  'No street parking',
  'HOA restrictions',
  'Permit required',
  'Steep driveway',
  'Space constraints',
  'Other',
];

export const addressTimeSlots = [
  'Early mornings (6:00 AM - 8:00 AM)',
  'Evenings (5:00 PM - 8:00 PM)',
  'Weekends (8:00 AM - 5:00 PM)',
];

export enum AddressTypeEnum {
  Delivery = 'delivery',
  Billing = 'billing',
}

export enum AddressProviderEnum {
  Manual = 'manual',
  Google = 'google',
}

export const addressTypeEnumValues = ['delivery', 'billing'] as const;

export const addressProviderEnumValues = ['manual', 'google'] as const;

export type AddressType = (typeof addressTypeEnumValues)[number];
export type AddressProvider = (typeof addressProviderEnumValues)[number];

export const addressZ = z.object({
  line1: z.string().min(3),
  line2: z.string().nullable().optional(),
  city: z.string().min(3),
  state: z.string().min(2).max(2),
  postalCode: z.string().regex(/^\d{5}(?:[-\s]\d{4})?$/),
  country: z.string().optional(),
  userId: z.string().optional(),
  type: z.enum(addressTypeEnumValues),
  googlePlacesId: z.string().optional(),
  provider: z.enum(addressProviderEnumValues).optional(),
  lat: z.number().optional(),
  long: z.number().optional(),
});

export type AddressZ = z.infer<typeof addressZ>;
